var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketZendesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89959 5.64078V13H1.80444L7.89959 5.64078ZM7.89959 3C7.89959 4.68264 6.53465 6.04757 4.85201 6.04757C3.16938 6.04757 1.80444 4.68264 1.80444 3H7.89959ZM8.9048 13C8.9048 11.3157 10.2681 9.95243 11.9524 9.95243C13.6367 9.95243 14.9999 11.3174 14.9999 13H8.9048ZM8.9048 10.3575V3H14.9999L8.9048 10.3575Z",
    fill: "#105342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketZendesk);
export default __webpack_public_path__ + "static/media/TicketZendesk.603e1abd51a21995189c311e713d362f.svg";
export { ForwardRef as ReactComponent };